import React, { useState } from 'react';
import { ProjectGq } from '../../../../../../../graphql/projects/models/ProjectGq';
import EditComboRequestView from './EditComboRequestView/EditComboRequestView';
import ChooseComboView from './ChoseComboView';

export interface AddComboKeywordsDialogProps {
  handleClose: () => void;
  reload: () => Promise<unknown>;
  project: ProjectGq;
}

export const AddComboKeywordsDialog: React.FC<AddComboKeywordsDialogProps> = ({
  handleClose,
  reload,
  project,
}) => {
  // Select combination
  const [comboId, setComboId] = useState<number>(undefined);

  if (comboId) {
    return (
      <EditComboRequestView
        project={project}
        comboRequestId={comboId}
        goToCombo={setComboId}
        handleClose={() => {
          setComboId(undefined);
          handleClose();
        }}
        reload={reload}
      />
    );
  }

  return <ChooseComboView project={project} handleClose={handleClose} setComboId={setComboId} />;
};

export default AddComboKeywordsDialog;
